import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { http, API } from "@/lib/api";
import { useI18n } from "@/lib/i18n";

const CATS = ["PRODUCT_IDENTITY", "MATERIALS", "ORIGIN", "REPAIR_CARE", "END_OF_LIFE", "FOOTPRINT", "CERTIFICATIONS"];
const CAT_LABELS_EN = {
  PRODUCT_IDENTITY: "Product identity", MATERIALS: "Materials", ORIGIN: "Where it's made",
  REPAIR_CARE: "Repair & care", END_OF_LIFE: "End of life", FOOTPRINT: "Footprint", CERTIFICATIONS: "Certifications",
};

const chipStyle = (status) => ({
  display: "inline-flex", alignItems: "center", gap: "6px",
  padding: "2px 10px", borderRadius: 999, fontSize: 11, fontWeight: 500, letterSpacing: "0.02em",
  textTransform: "uppercase", border: "1px solid",
  ...(status === "FOUND"
    ? { color: "#2E7D32", background: "#E8F5E9", borderColor: "#A5D6A7" }
    : status === "PARTIAL"
    ? { color: "#B97700", background: "#FFF8E1", borderColor: "#FFE082" }
    : { color: "#616161", background: "#EEEEEE", borderColor: "#E0E0E0" }),
});

/**
 * Embed page — designed to be rendered inside an iframe.
 * URL: /embed/:slug
 * Also served by /api/embed.js loader script that injects an iframe pointing here.
 */
export default function Embed() {
  const { slug } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => { http.get(`/embed/${slug}`).then((r) => setData(r.data)).catch(() => {}); }, [slug]);

  if (!data) return null;
  const last = (data.last_reviewed_at || "").slice(0, 10);

  return (
    <div style={{
      fontFamily: "'Chivo', system-ui, sans-serif",
      background: "#F8F8F5", color: "#1A1A18",
      padding: 20, minHeight: 400, boxSizing: "border-box",
    }} data-testid="embed-root">
      <div style={{ borderBottom: "1px solid #D6D6D0", paddingBottom: 12, marginBottom: 12 }}>
        <div style={{ fontSize: 10, textTransform: "uppercase", letterSpacing: "0.2em", color: "#73736C" }}>BRANDPASSPORT</div>
        <div style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontSize: 22, marginTop: 4 }}>{data.brand.display_name}</div>
        <div style={{ fontSize: 11, fontFamily: "monospace", color: "#73736C", marginTop: 2 }}>
          {data.brand.sector_code} · Last checked: {last}
        </div>
      </div>
      <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
        {CATS.map((cat) => {
          const it = data.checklist.find((c) => c.category === cat);
          if (!it) return null;
          return (
            <li key={cat} style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: "1px solid #EEE", fontSize: 13 }}>
              <span>{CAT_LABELS_EN[cat]}</span>
              <span style={chipStyle(it.status)}>{it.status === "NOT_FOUND" ? "Not found" : it.status.toLowerCase()}</span>
            </li>
          );
        })}
      </ul>
      <a href={data.profile_url} target="_blank" rel="noopener noreferrer" style={{
        display: "inline-block", marginTop: 12, padding: "6px 12px", border: "1px solid #1A1A18",
        fontSize: 12, textDecoration: "none", color: "#1A1A18",
      }} data-testid="embed-full-link">View full profile on BrandPassport →</a>
      <div style={{ fontSize: 10, color: "#73736C", marginTop: 16, borderTop: "1px solid #EEE", paddingTop: 8 }} data-testid="embed-disclaimer">
        {data.disclaimer}
      </div>
    </div>
  );
}
